import GlobalButton from '../../components/ui/GlobalButton';
import { CrafterLogoMark } from '../../icons/svgs';

export default function MobileScreen() {
  return (
    <div className="min-h-screen bg-frame-main mx-auto max-w-[500px] md:max-w-[700px] sm:w-full flex flex-col items-center justify-center px-[10px] sm:px-[20px]">
      <div className="flex flex-col items-center">
        <div className="w-[50px] mb-[20px]">
          <CrafterLogoMark />
        </div>
        <h1 className="text-text-primary-body text-center text-base md:text-lg font-medium  w-full md:w-[70%] leading-[26px] md:leading-[24px]">
          For the best Crafter experience, we recommend a desktop browser or a
          larger window size.
        </h1>
        <p className="text-text-primary-body mt-4">Thank you!</p>

        <GlobalButton
          className={`mt-[50px]`}
          to={'https://usecrafter.com'}
          variant={'purple'}
          state={'default'}
          size={'md'}
        >
          Back To Home
        </GlobalButton>
      </div>
    </div>
  );
}
